import formatBasisPoints from 'src/public/formatBasisPoints/formatBasisPoints';
import formatCurrency from 'src/public/formatCurrency/formatCurrency';
import formatDateTime from 'src/public/formatDateTime/formatDateTime';
import formatDisplayName from 'src/public/formatDisplayName/formatDisplayName';
import formatList from 'src/public/formatList/formatList';
import formatMessage from 'src/public/formatMessage/formatMessage';
import formatNumber from 'src/public/formatNumber/formatNumber';
import formatPercent from 'src/public/formatPercent/formatPercent';
import formatRelativeTime from 'src/public/formatRelativeTime/formatRelativeTime';
import isTranslated from 'src/public/isTranslated/isTranslated';

import type {IAnalytics, IReports} from '@sail/observability';
import type {FormatListDeclarativeOverloaded} from 'src/public/formatList/types';
import type {FormatMessageDeclarative} from 'src/public/formatMessage/formatMessage';
import type {IntlHook} from 'src/public/useIntl/types';
import type {IntlConfig} from 'src/types';

export default function createIntlObject(
  config: IntlConfig,
  reports: IReports,
  analytics: IAnalytics,
): IntlHook {
  return {
    formatBasisPoints: formatBasisPoints.bind(null, config, reports, analytics),
    formatCurrency: formatCurrency.bind(null, config, reports),
    formatDateTime: formatDateTime.bind(null, config, reports, analytics),
    formatDisplayName: formatDisplayName.bind(null, config, reports),
    formatList: formatList.bind(
      null,
      config,
      reports,
    ) as FormatListDeclarativeOverloaded,
    formatMessage: formatMessage.bind(
      null,
      config,
      reports,
      analytics,
    ) as FormatMessageDeclarative,
    formatNumber: formatNumber.bind(null, config, reports, analytics),
    formatPercent: formatPercent.bind(null, config, reports, analytics),
    formatRelativeTime: formatRelativeTime.bind(
      null,
      config,
      reports,
      analytics,
    ),
    isTranslated: isTranslated.bind(null, config, reports, analytics),
    locale: config.locale,
  };
}
